<div class="backdrop" @showHide *ngIf="backdrop.active" (click)="hideBackdrop()" [style.z-index]="backdrop.zIndex"></div>